import { useEffect, useContext } from 'react';
import { AppContext, createAppUser } from '../contexts/AppContext';
import { useHistory } from 'react-router';
import authService from '@/services/authService';
import { HIDE_MESSAGE_401_PARAMS } from '@/config';
import { apiSdk } from '@/httpClient';
import { AppUrls, UnauthorizedUrl } from '@/urls';
import { getUrlQueryValue } from './useQuery';

const getCallBackUrl = () => {
  let url = getUrlQueryValue('callback');
  if (url) {
    return encodeURIComponent(url);
  }
  const { pathname, search } = window.location;
  return encodeURIComponent(`${pathname}${search}`);
};

const checkHasAccessToken = () => {
  if (document.visibilityState === 'visible') {
    const token = authService.getAccessToken();
    if (!token) {
      authService.redirect2LogoutPage();
    }
  }
};

const useAuth = () => {
  const context = useContext(AppContext);
  const history = useHistory();
  const { pathname } = window.location;

  const getCurrentUser = () => {
    apiSdk.AgentUserService.currentUser({ params: { [HIDE_MESSAGE_401_PARAMS]: true } })
      .then(auth => {
        if (auth) {
          context.onUpdateContext({
            auth: createAppUser(auth),
            authLoaded: true,
          });
          authService.logUserInfo2Sentry(auth.id, auth.email, auth.username);
        } else {
          authService.clearOnLogout();
          context.onUpdateContext({
            auth: null,
            authLoaded: true,
          });
          if (!UnauthorizedUrl.some(x => pathname.startsWith(x))) {
            let callbackUrl = getCallBackUrl();
            const nextUrl = callbackUrl ? `${AppUrls.Login}?callback=${callbackUrl}` : AppUrls.Login;
            history.push(nextUrl);
          }
        }
      })
      .catch(error => {
        authService.clearOnLogout();
        context.onResetContext();
        if (!UnauthorizedUrl.some(x => pathname.startsWith(x))) {
          let callbackUrl = getCallBackUrl();
          const nextUrl = callbackUrl ? `${AppUrls.Login}?callback=${callbackUrl}` : AppUrls.Login;
          history.push(nextUrl);
        }
      });
  };

  useEffect(() => {
    if (context.auth) {
      document.addEventListener('visibilitychange', checkHasAccessToken);
    }
    return () => {
      document.removeEventListener('visibilitychange', checkHasAccessToken);
    };
  }, [context]);

  useEffect(() => {
    const tokenStr = authService.getAccessToken();
    if (tokenStr) {
      getCurrentUser();
    } else {
      context.onUpdateContext({
        auth: null,
        authLoaded: true,
      });
      if (!UnauthorizedUrl.some(x => pathname.startsWith(x))) {
        let callbackUrl = getCallBackUrl();
        const nextUrl = callbackUrl ? `${AppUrls.Login}?callback=${callbackUrl}` : AppUrls.Login;
        history.push(nextUrl);
      }
    }
  }, []); // run one time
  return true;
};

export default useAuth;
